// extracted by mini-css-extract-plugin
export default {"Notes__Input":"styles_Notes__Input__wOTnP","Notes__Input_edit":"styles_Notes__Input_edit__PRE--","Notes__noteBy":"styles_Notes__noteBy__KV38P"};